import React from 'react'
import classnames from 'classnames'

import TableErrorBoundary from '../Features/ErrorBoundary'
import { getTableCellStyle, isColumnFreezed } from '../TableHelper'
import { getFreezeColumnCount, getMinMaxStyle, EMPTY_ROW_ID } from '../util'

const RenderCell = (props) => {
  const {
    row,
    viewBy,
    isResizable,
    equalWidthColumns,
    columnWidthsObjectProp,
    columnWidthsObjectState,
    columnResizing,
    isRowSelect,
    listData
  } = props
  return row.cells.map((cell: any, i) => {
    let cellProps = cell.getCellProps()
    if (isResizable) {
      cellProps = cell.getCellProps({
        style: getMinMaxStyle(props.tableWidth)
      })
    }

    let cellStyle = getTableCellStyle({
      column: cell.column,
      columns: props.columns,
      cellProps,
      columnWidthsObjectState,
      columnWidthsObjectProp,
      equalWidthColumns,
      columnResizing,
      isResizable,
      tableRowAction: props.v2Features.tableRowAction
    })

    let freezeColumnCount = 0
    if (isResizable) {
      //todo remove this is not being used test in master branch first
      cellStyle = {
        ...cellStyle,
        position: 'relative'
      }
    }

    if (props.canFreezeColumn) {
      freezeColumnCount = getFreezeColumnCount(listData, isRowSelect)
      if (i > 0 && isColumnFreezed(freezeColumnCount, i)) {
        cellStyle = { ...cellStyle, left: cell.column.totalLeft }
      }
    }
    if (cell.column.id === 'selection') {
      return (
        <div
          {...cell.getCellProps()}
          data-test-id={cell.column.testId}
          className={
            'Table-select-body flex-v-center' +
            (isColumnFreezed(freezeColumnCount, i) || props.canFreezeCheckbox ? ' freezed ' : ' ')
          }>
          {
            row.id === EMPTY_ROW_ID ? null :
              <TableErrorBoundary>{cell.render('Cell')}</TableErrorBoundary>}
        </div>
      )
    }

    return (
      <div
        role="cell"
        data-test-id={cell.column.testId}
        className={classnames(
          'Table__body__column',
          isColumnFreezed(freezeColumnCount, i) && 'freezed',
          !!cell.column.cssClass && cell.column.cssClass,
          cell.column.isSorted && 'Table__body__column--sorted',
          viewBy === 'Compact' && 'Table__body__column--compact',
          isResizable && 'Table__body__column__resize',
          freezeColumnCount > 0 && freezeColumnCount === i + 1 && 'freezed_border',
          cell.column.id === 'tableActions' && props.v2Features.tableRowAction && 'Table__body__cell--tableRowAction',
          row.index === 0 &&
          cell.column.id === 'tableActions' &&
          props.totalCounts > 0 &&
          !props.customRowAdd &&
          'Table__body__cell--firstTableRowAction'
        )}
        style={cellStyle}
        key={cell.column.id + i}>
        {
          row.id === EMPTY_ROW_ID ? null :
            <>
              <TableErrorBoundary>{cell.render('Cell')}</TableErrorBoundary>
              {isResizable && i >= 0 ? <span className={`resizer `}></span> : ''}

            </>

        }
      </div>
    )
  })
}

export default RenderCell